module.exports = __webpack_public_path__ + "fefe68e8c4b03cc52e1a5db22c1598cf.jpg";